import Section, { SectionVisibilityProps } from './Section';
import { useTranslation } from 'react-i18next';
import { ORDER_METHODS } from '../../../services/exports/Constants';
import TextInput from '../../inputs/TextInput';
import TextArea from '../../inputs/TextArea';
import useOrderFlow from '../../../hooks/order/useOrderFlow';
import { SectionType } from './CheckoutInfoBag';

export default function OrderMethodDetailsSection({ show }: SectionVisibilityProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Checkout:Sections:OrderMethodDetailsSection' });

  const { localData, update } = useOrderFlow();

  return (
    (localData.method === ORDER_METHODS.DELIVERY || localData.method === ORDER_METHODS.ROOM_SERVICE) && (
      <Section
        hideDivider
        show={show}
        id={SectionType.order_method_details}
        title={t(
          localData.method === ORDER_METHODS.DELIVERY
            ? `title.${localData.method}`
            : `title.${localData.method}.${localData.room_service_location?.type}`,
        )}
        className="p-md bordered"
        containerClassName="lg:px-none px-md pb-md"
      >
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-2">
          {localData.method === ORDER_METHODS.DELIVERY && (
            <>
              <TextInput
                type="text"
                value={localData.delivery_doorbell_name}
                placeholder={t('form.doorbell_name.placeholder')}
                className="lg:col-span-1 col-span-2"
                onChange={(value) => update('delivery_doorbell_name', value)}
              />
              <TextInput
                type="text"
                value={localData.delivery_company_name}
                placeholder={t('form.company_name.placeholder')}
                className="lg:col-span-1 col-span-2"
                onChange={(value) => update('delivery_company_name', value)}
              />
              <TextArea
                maxLength={80}
                value={localData.customer_note}
                containerClassName="col-span-2"
                placeholder={t('form.customer_note.placeholder')}
                onChange={(value) => update('customer_note', value)}
              />
            </>
          )}
          {localData.method === ORDER_METHODS.ROOM_SERVICE && (
            <TextArea
              maxLength={160}
              value={localData.order_instructions}
              containerClassName="col-span-2"
              placeholder={t('form.order_instructions.placeholder')}
              onChange={(value) => update('order_instructions', value)}
            />
          )}
        </div>
      </Section>
    )
  );
}
